function buildEvents(category) {
    var eventsList = $('#eventsList');
    if (eventsList.length) {
        var config = {
            method: 'getEvents',
            filterBy: '',
            name: '',
            limit: '3',
            startDate: 'now',
            sessionOrderBy: 'start_date'
        };
        if (category) {
            config.filterBy = 'category';
            config.name = category;
        }
        $.ajax({
            method: "GET",
            url: 'https://events.flinders.edu.au/json/',
            headers: {},
            data: config
        }).done(function (data) {
            var events = data.events;
            var eventTemplate = $('#event').text();
            var compiledEventTemplate = doT.template(eventTemplate);
            var dataToProvide;
            for (var i = 0; i < data.limit; i++) {
                dataToProvide = events[i];
                dataToProvide.eventUrl = 'http://events.flinders.edu.au/' + dataToProvide.url;
                dataToProvide.calendarUrl = 'http://events.flinders.edu.au/session/ical/id/' + dataToProvide.id;
                dataToProvide.date = new Date(moment(dataToProvide.sessions[0].start_date));
                dataToProvide.date_day = moment(dataToProvide.date).format('DD');
                dataToProvide.date_month = moment(dataToProvide.date).format('MMM');
                dataToProvide.date_time = moment(dataToProvide.date).format('HH:mm a');
                dataToProvide.place = dataToProvide.sessions[0].location;
                
                eventsList.append(compiledEventTemplate(dataToProvide));
            }
        });
    }
}

